import React from "react";


const Assetsmonitoring = () => {
  document.title = "Assets-monitoring";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>Assets-monitoring</h1>
        
      </div>
    </React.Fragment>
  );
};

export default Assetsmonitoring;
